import { Directive, DOCUMENT, Inject, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { filter, from, fromEvent, map, switchMap, toArray, zip } from 'rxjs';
import { ENVIRONMENT } from '@fatigue/app/core/providers/environment.provider';
// import { TOGGLE_DEV_MODE } from '@fatigue/app/core/store/actions/localization.actions';
import { Environment } from '@fatigue/environments/env';

@Directive({ standalone: true })
export class LabelDevDirective implements OnInit {
  private readonly combination: Array<string> = ['ControlLeft', 'AltLeft', 'KeyT'];
  constructor(
    @Inject(ENVIRONMENT) private _env: Environment,
    @Inject(DOCUMENT) private _document: Document,
    private _store: Store,
  ) {}

  ngOnInit(): void {
    if (this._env.name === 'dev' || this._env.name === 'sandbox') {
      const keydown$ = fromEvent<KeyboardEvent>(this._document, 'keydown').pipe(filter((event) => !event.repeat));
      from(this.combination)
        .pipe(
          map((code) => {
            return keydown$.pipe(filter((event) => event.code === code));
          }),
          toArray(),
          switchMap((x) => zip(...x)),
        )
        .subscribe(() => {
          // this._store.dispatch(TOGGLE_DEV_MODE());
        });
    }
  }
}
